(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const selects = document.querySelectorAll('.contact-form__select');
    
    selects.forEach(select => {
      // Check if select has a value on load
      if (select.value !== '') {
        select.classList.add('has-value');
      }
      
      // Update on change
      select.addEventListener('change', function() {
        if (this.value !== '') {
          this.classList.add('has-value');
        } else {
          this.classList.remove('has-value');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
